module.exports = __webpack_public_path__ + "e897db2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/icons/home-004.jpg
// module id = 1310
// module chunks = 8